import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConsentManagerCookiesService {
  private readonly renderer: Renderer2;

  public constructor(private readonly rendererFactory: RendererFactory2) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  public async createConsentManagerScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      const scriptId: string = 'consent-manager-script';

      if (document.getElementById(scriptId)) {
        resolve();
        return;
      }

      const scriptTag: HTMLScriptElement = this.renderer.createElement('script');

      this.renderer.setAttribute(scriptTag, 'id', scriptId);
      this.renderer.setAttribute(scriptTag, 'type', 'text/javascript');
      this.renderer.setProperty(scriptTag, 'src', 'https://cdn.consentmanager.net/delivery/js/semiautomatic.min.js');
      this.renderer.setAttribute(scriptTag, 'data-cmp-ab', '1');
      this.renderer.setAttribute(scriptTag, 'data-cmp-cdid', '916b540462560');
      this.renderer.setAttribute(scriptTag, 'data-cmp-host', 'a.delivery.consentmanager.net');
      this.renderer.setAttribute(scriptTag, 'data-cmp-cdn', 'cdn.consentmanager.net');
      this.renderer.setAttribute(scriptTag, 'data-cmp-codesrc', '0');

      scriptTag.onload = () => resolve();
      scriptTag.onerror = () => reject(new Error('Consent Manager script failed to load'));

      this.renderer.appendChild(document.head, scriptTag);
    });
  }
}

export function initializeConsentManagerScript(cookieConsent: ConsentManagerCookiesService): () => Promise<void> {
  return async () => cookieConsent.createConsentManagerScript();
}
